import React, { useState } from "react";
import logoLight from "../../assets/images/logo.png";
import logoDark from "../../assets/images/logo.png";
import SignupForm from "../../components/SignupForm";

const RegisterPage = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <div className="login-page">
      <div className="left-panel">
        <p className="left-logo">
          <img
            src={isDarkMode ? logoDark : logoLight}
            alt="healthscope.ai"
            className="d-inline-block align-top"
          />
        </p>
      </div>

      <div className="right-panel">
        <SignupForm />
      </div>
    </div>
  );
};

export default RegisterPage;
